export enum MemberLoadOption {
    /**
     * Restricts getting members to members that are already loaded.
     */
    LocalOnly,
    /**
     * Allows members to be lazy loaded when needed.
     * For performance reasons, this should be used wisely.
     */
    LazyLoading,
}
